// Import Bootstrap javaScript modules as needed:
import { Collapse, Dropdown, Modal, Tab } from '/node_modules/bootstrap/dist/js/bootstrap.bundle';

// Make Bootstrap modules avaliable globally
window.bootstrap = {
    Collapse, Dropdown, Modal, Tab
}

// Import custom modules
import { debounce, throttle, pageLanguage, reduceMotion, isMobile, onScrolledDown, scrollTop, scrollDirection } from './modules/utility.js';
// Make custom utility modules avaliable globally
window.debounce = debounce;
window.throttle = throttle;
window.pageLanguage = pageLanguage;
window.reduceMotion = reduceMotion;
window.isMobile = isMobile;
window.scrollTop = scrollTop;
window.scrollDirection = scrollDirection;

import { globalSearch } from './modules/globalsearch.js';
import { globalMenuBackdrop, toggleGlobalMenu, localMenuToggles, handleOverflowingMenu } from './modules/header.js';
import { initMobileMenu, mobileMenuDetect } from './modules/mobilemenu.js';
import { runFooter, getFooterHeight, scrollToBottom } from './modules/footer.js';

// Global custom functions
document.addEventListener('DOMContentLoaded', () => {
    
    onScrolledDown(80);
    runFooter();
    getFooterHeight();
    scrollTop();
    scrollToBottom();
    globalSearch();

    if (isMobile()) {
        scrollDirection();
        toggleGlobalMenu();
    }

    if (isMobile() || document.querySelector('body.compact-menu-site')) {
        initMobileMenu();
    }

    if (!isMobile()) {
        handleOverflowingMenu();
        localMenuToggles();
        globalMenuBackdrop();
    }
    window.addEventListener('scroll', throttle(function () {
        onScrolledDown(80);
        if (isMobile()) {
            scrollDirection();
        }
    }, {
        passive: true
    }, 80));

    window.addEventListener('resize', debounce(function () {
        onScrolledDown(80);
        getFooterHeight();
        if (isMobile()) {
            scrollDirection();
            mobileMenuDetect();
        }
        if (!isMobile()) {
            handleOverflowingMenu();
            globalMenuBackdrop();
        }
    }, 100));

});